var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md", withBgClickEvent: true },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-row justify-between items-center" },
              [
                _c("div", [
                  _c(
                    "p",
                    {
                      staticClass: "text-primary-black font-semibold text-base",
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _c(
                    "p",
                    {
                      staticClass:
                        "text-primary-black font-normal pt-1 text-sm",
                    },
                    [
                      _vm._v(
                        " Here’s a list of Resources already part of the platform who can help with this task. "
                      ),
                    ]
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass:
                      "ml-2 mr-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                      mouseover: function ($event) {
                        _vm.isHovered = true
                      },
                      mouseout: function ($event) {
                        _vm.isHovered = false
                      },
                    },
                  },
                  [
                    !_vm.isHovered
                      ? _c("CrossIcon", { staticClass: "h-4 w-4" })
                      : _vm._e(),
                    _vm.isHovered
                      ? _c("CrossIconHover", { staticClass: "h-4 w-4" })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              {},
              [
                _c("SuggestedResourceTable", {
                  attrs: { suitableContractors: _vm.suitableContractors },
                }),
                _c("CardPagination", {
                  attrs: { config: _vm.paginationConfig },
                  on: {
                    "update:config": function ($event) {
                      _vm.paginationConfig = $event
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }